import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogContentText,
  DialogActions,
} from "@mui/material";

function ConfirmationDialog(props) {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.secondary" }}>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary" sx={{ textTransform: "none", fontWeight: 600 }}>
          No
        </Button>
        <Button onClick={props.onYes} color="primary" autoFocus sx={{ textTransform: "none", fontWeight: 600 }}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
